import {
  GET_WEB_HOOKS_PROCESS_LIST,
  GET_WEB_HOOKS_PROCESS_LIST_SUCCESS,
  GET_WEB_HOOKS_PROCESS_LIST_ERROR,
  GET_WEB_HOOKS,
  GET_WEB_HOOKS_SUCCESS,
  GET_WEB_HOOKS_ERROR,
  POST_WEB_HOOKS_INSERT_SUCCESS,
  POST_WEB_HOOKS_INSERT_ERROR,
  POST_WEB_HOOKS_INSERT,
  POST_WEB_HOOKS_UPDATE,
  POST_WEB_HOOKS_UPDATE_SUCCESS,
  POST_WEB_HOOKS_UPDATE_ERROR,
  PUT_WEB_HOOKS_DELETE_SUCCESS,
  PUT_WEB_HOOKS_DELETE_ERROR,
  PUT_WEB_HOOKS_DELETE,
} from "./actionType"

// get api for webhook action
export const getWebHookProcessList = () => ({
  type: GET_WEB_HOOKS_PROCESS_LIST,
})

export const getWebHookProcessListSuccess = WebHook => ({
  type: GET_WEB_HOOKS_PROCESS_LIST_SUCCESS,
  payload: WebHook,
})

export const getWebHookProcessListError = error => ({
  type: GET_WEB_HOOKS_PROCESS_LIST_ERROR,
  payload: error,
})

// get api for webhook action
export const getWebHook = () => ({
  type: GET_WEB_HOOKS,
})

export const getWebHookSuccess = WebHook => ({
  type: GET_WEB_HOOKS_SUCCESS,
  payload: WebHook,
})

export const getWebHookError = error => ({
  type: GET_WEB_HOOKS_ERROR,
  payload: error,
})

// post insert api for webhook action
export const getWebHookInsert = data => ({
  type: POST_WEB_HOOKS_INSERT,
  payload: data,
})

export const getWebHookInsertSuccess = WebHook => ({
  type: POST_WEB_HOOKS_INSERT_SUCCESS,
  payload: WebHook,
})

export const getWebHookInsertError = error => ({
  type: POST_WEB_HOOKS_INSERT_ERROR,
  payload: error,
})

// post update api for webhook action
export const getWebHookUpdate = data => ({
  type: POST_WEB_HOOKS_UPDATE,
  payload: data,
})

export const getWebHookUpdateSuccess = WebHook => ({
  type: POST_WEB_HOOKS_UPDATE_SUCCESS,
  payload: WebHook,
})

export const getWebHookUpdateError = error => ({
  type: POST_WEB_HOOKS_UPDATE_ERROR,
  payload: error,
})
// post Delete api for webhook action
export const getWebHookDelete = id => ({
  type: PUT_WEB_HOOKS_DELETE,
  payload: id,
})

export const getWebHookDeleteSuccess = WebHook => ({
  type: PUT_WEB_HOOKS_DELETE_SUCCESS,
  payload: WebHook,
})

export const getWebHookDeleteError = error => ({
  type: PUT_WEB_HOOKS_DELETE_ERROR,
  payload: error,
})
